import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { AlertDetailDemoService } from 'src/app/design/demo-services/alert-detail-demo.service';


@Injectable({
  providedIn: 'root'
})
export class AlertDetailService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: AlertDetailDemoService) { }

  getAlertDetailData(id: string): Observable<any> {
    
    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/alertHistoryItem?id=${id}`;
    
    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get(id) : this.http.get(url))
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: false, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        const ret = d.isError === true ? d : {

          detail: d.Item,
          Exception: d.Exception,
          LastUpdated: environment.demo ? new Date().toLocaleString() : d.LastUpdated,
          isNotFound: !d.Item,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}
